import { API_URL } from '../../config';
import { toApiError } from '../../lib/api-error';

export type StartWorkflowTestRunOptions = {
  tag?: string;
  propertyId?: string;
  environmentId?: string;
  /**
   * Clear `degraded` health on the in-scope flows before running, so this run
   * covers them instead of skipping them. Persistent: they stay in future runs
   * until they fail repeatedly again.
   */
  reEnableDegraded?: boolean;
};

export type StartWorkflowTestRunResponse = {
  ok: boolean;
  suiteId?: string | null;
  startedAt?: string | null;
};

export async function startWorkflowTestRun(
  options?: StartWorkflowTestRunOptions
): Promise<StartWorkflowTestRunResponse> {
  const response = await fetch(`${API_URL}/workflows/test-runs`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      tags: options?.tag ? [options.tag] : [],
      propertyId: options?.propertyId,
      environmentId: options?.environmentId,
      // Omitted unless opted in — the server treats absent as "keep skipping".
      reEnableDegraded: options?.reEnableDegraded ? true : undefined,
    }),
  });

  if (!response.ok) {
    throw await toApiError(response, 'Failed to start test run');
  }

  return response.json();
}
